module.exports = __webpack_public_path__ + "static/media/09C.bf69444e.png";